import { AlpineComponent } from 'alpinejs';

type HeaderData = {
  toggleMainNav: () => void,
  toggleSchwerpunkteNav: (event: Event) => void,
  toggleSubNav: (event: Event) => void,
}

export default ():AlpineComponent<HeaderData> => ({
  toggleMainNav() {
    const mainMenu = document.getElementById('main-menu');
    if (mainMenu) {
      mainMenu.classList.toggle('toggled');

      // Close Schwerpunkte menu
      if (mainMenu.classList.contains('toggled')) {
        const schwerpunkteMenu = mainMenu.querySelector('.menu-hauptmenue-intern > li.is-opened');
        if (schwerpunkteMenu) {
          schwerpunkteMenu.classList.remove('is-opened');
        }
      }
    }
  },

  toggleSchwerpunkteNav(event: Event) {
    event.preventDefault();
    const eTarget = event.currentTarget as HTMLElement;
    const navItem = eTarget.closest('.menu-item');
    if (navItem?.classList.contains('menu-item-has-children')) {
      navItem.classList.toggle('is-opened');
    }

    // Close main menu
    if (navItem?.classList.contains('is-opened')) {
      const mainMenu = document.getElementById('main-menu');
      if (mainMenu) {
        mainMenu.classList.remove('toggled');
      }
    }
  },

  toggleSubNav(event: Event) {
    event.preventDefault();
    const eTarget = event.currentTarget as HTMLElement;
    const navItem = eTarget.closest('.menu-item');
    navItem?.classList.toggle('is-opened');
  }
});
